module.exports = __webpack_public_path__ + "static/media/Simpy.8b19d1c6.png";